import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { isNullOrUndefined, isNull } from '../../../models/utils';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, ModalTargetType } from '../../../models/enums';
import { IndexSettings, Languages } from '../../../models/index-settings';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';

export interface OCRSettingsModalData {
    targetType: ModalTargetType;
    targets: any;
    viewHandle: string;
}

@Component({
    standalone: false,
    selector: 'res-ocr-settings',
    templateUrl: './ocr-settings.component.html',
    styleUrls: ['./ocr-settings.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OcrSettingsComponent extends BaseModalComponent implements OnInit {
    selectedLanguage: Languages;
    languages: any;
    ocrAccuracyHigh: boolean;
    ocrPageTimeout: number;
    OCRSettingsModalData: OCRSettingsModalData;

    // modal info
    modalTitle = 'OCR Settings';
    modalClass = 'ocr-settings-modal';
    modalAutomationId = 'ocr-settings';
    primaryButtonLabel = 'Run OCR';
    secondaryButtonLabel = 'Cancel';
    modalHelpIndex = HelpIndex.automatic_ocr_settings;
    isBusy = false;
    isBusyMessage = 'OCR Settings loading ...';
    showErrorPopup: boolean;

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        const handle = this.modalData && this.modalData.handle ? this.modalData.handle : this.commonService.currentProject.handle;
        this.languages = Languages;
        this.selectedLanguage = Languages.GENERAL;
        this.loadData(handle);
        this.OCRSettingsModalData = this.modalData as OCRSettingsModalData;
    }

    loadData(handle) {
        this.isBusy = true;
        this.restService.post(Endpoint.projectManager_getIndexSettings, { handle: handle }).then(response => {
            this.isBusy = false;
            if (response && response.settings) {
                const settings = new IndexSettings(response.settings);
                this.selectedLanguage = settings.ocrLanguage ? Languages[settings.ocrLanguage] : Languages.GENERAL;
                this.ocrAccuracyHigh = settings.ocrAccuracyHigh;
                this.ocrPageTimeout = settings.ocrPageTimeout;
            }
        }, () => {
            this.isBusy = false;
        });
    }

    runOCR() {
        if (this.OCRSettingsModalData && this.OCRSettingsModalData.viewHandle && this.OCRSettingsModalData.targets) {
            this.isBusyMessage = 'Running OCR...';
            this.isBusy = true;
            const viewHandle = this.commonService.matrixGridsSelection?.openFromDocumentActionBtn ? this.commonService.matrixGridsSelection?.viewHandle : this.OCRSettingsModalData.viewHandle;
            const viewName = (this.commonService.matrixGridsSelection?.openFromDocumentActionBtn && this.commonService.matrixGridsSelection?.viewName) ? this.commonService.matrixGridsSelection?.viewName : this.OCRSettingsModalData.targets.name;
            this.restService.post(Endpoint.viewManager_canReprocess, { handle: viewHandle }).then(responseCanReprocess => {
                if (responseCanReprocess && responseCanReprocess.percentComplete === 100) {
                    this.restService.post(Endpoint.viewManager_canReprocessResult, { handle: responseCanReprocess.handle }).then(responseCanReprocessResult => {
                        this.isBusy = false;
                        if (responseCanReprocessResult && responseCanReprocessResult.valid) {
                            let endpoint: Endpoint;
                            const reqMsg: any = {
                                ocrAccuracyHigh: this.ocrAccuracyHigh,
                                ocrLanguage: this.selectedLanguage.toUpperCase(),
                                ocrPageTimeout: this.ocrPageTimeout
                            };
                            if (this.OCRSettingsModalData.targetType === ModalTargetType.view) {
                                reqMsg.taskDescription = 'OCR Processing View ' + viewName;
                                reqMsg.viewHandle = viewHandle;
                                endpoint = Endpoint.corpusManager_ocrFromView;
                            } else {
                                reqMsg.taskDescription = 'OCR Processing Documents';
                                endpoint = Endpoint.corpusManager_ocrFromDocuments;
                                reqMsg.documentHandleList = this.OCRSettingsModalData.targets;
                            }
                            this.restService.post(endpoint, reqMsg).then(response => {
                                console.log(response);
                            });
                            this.closeModal();
                        }
                        if (responseCanReprocessResult && responseCanReprocessResult.reason) {
                            this.commonService.openErrorModal('View has documents from a Shared DataSet used by this project');
                            this.closeModal();
                        }
                    }, () => {
                        this.isBusy = false;
                    });
                }
            }, () => {
                this.isBusy = false;
            });
        }
    }

    isRunOCREnabled(): boolean {
        if (isNullOrUndefined(this.ocrPageTimeout) || this.ocrPageTimeout === 0 || this.ocrPageTimeout.toString() === '0' || this.isBusy) {
            return false;
        }
        return true;
    }

    updateAutoOCRPageTimeout(value): void {
        this.showErrorPopup = false;
        if ((isNull(this.ocrPageTimeout) && value.data === '0') || (this.ocrPageTimeout === 0 && value.data === '0')) {
            this.ocrPageTimeout = null;
            this.showErrorPopup = true;
        }

        const autoOCRPageTimeoutRequired = this.ocrPageTimeout ? false : true;

        if (autoOCRPageTimeoutRequired) {
            this.showErrorPopup = true;
        }
    }
}
